import { ampli } from 'lib-shared-tracking';
import { useState } from 'react';

import { useAppDispatch } from 'utils/redux/useAppDispatch';

import Image from '../../../../../shared/Image/Image';
import { actions } from '../../../../../shared/attachmentsPreviewModal/actions/attachmentsPreviewModal';
import { AttachedFile } from '../AttachedFile';

import styles from './inlinedImage.module.scss';

const { attachmentsPreviewModalOpen } = actions;

type InlinedImageProps = {
  /** The image src. */
  src: string;
  /** The image alt text. */
  alt?: string;
  /** A number to use as part of the file name. */
  number?: number;
  /**
   * Whether or not to use a fallback in case the image cannot be loaded. In
   * this case we present it with the `AttachedFile` component.
   */
  attachedFileFallback?: boolean;
};

export const InlinedImage = (props: InlinedImageProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const { alt, number, src, attachedFileFallback } = props;
  const [showFallback, setShowFallback] = useState(false);
  const [url, setUrl] = useState<string>();

  const handleOnClick = () => {
    if (url) {
      dispatch(attachmentsPreviewModalOpen({ fileName: 'inlined.jpg', url }));
      ampli.conversationAttachedImageIsViewed();
    }
  };

  const handleOnLoad = (url: string) => {
    setUrl(url);
  };

  const handleError = (error: string) => {
    if (attachedFileFallback) {
      setShowFallback(true);
    }
  };

  return (
    <>
      {showFallback ? (
        <AttachedFile
          prettyName={alt ?? `attached_file_${number}`}
          fileUrl={src}
        />
      ) : (
        <div className={styles.inlinedImage} onClick={handleOnClick}>
          <Image
            className={styles.image}
            onErrorHandler={handleError}
            onLoad={handleOnLoad}
            alt={alt}
            src={src}
          />
        </div>
      )}
    </>
  );
};
